export default "__VITE_ASSET__BcxUV3Tl__"